const parseRouteSegmentId = (segment: string | undefined) => {
  if (!segment || !/^\d+$/.test(segment)) return null
  return parseInt(segment, 10)
}

const matchesRoutePrefix = (pathname: string | undefined, prefix: string) => {
  if (!pathname) return false
  return pathname === prefix || pathname.startsWith(`${prefix}/`)
}

export const getEnvSetup = ({
  pathname,
  host,
}: {
  pathname: string
  host: string
}) => {
  const isKidsPreview = matchesRoutePrefix(pathname, "/kids/preview")
  const isKids = isKidsPreview || host.split(".")[0] === "kids"
  const isPublic = matchesRoutePrefix(pathname, "/publiek")
  const isSubmitted =
    pathname?.indexOf("/ingeleverd") === 0
      ? (parseRouteSegmentId(pathname.split("/")[2]) ?? undefined)
      : undefined
  const isReopened =
    pathname?.indexOf("/heropened") === 0
      ? parseRouteSegmentId(pathname.split("/")[2])
      : null
  const isExamine =
    pathname?.indexOf("/nakijken") === 0
      ? (parseRouteSegmentId(pathname.split("/")[2]) ?? undefined)
      : undefined

  return {
    isKids,
    isKidsPreview,
    isPublic,
    isSubmitted,
    isReopened,
    isExamine,
  }
}
